import NavigationHeader from 'components/molecules/navigation-header';
import { useTranslation } from 'react-i18next';
import withLoader from 'components/organisms/withLoader';
import BaseDownloadButton from 'components/atoms/download-button';

import s from './styles.module.scss';

import type { FC } from 'react';

interface NormalReadingsReportHeaderProps {
  isLoading: boolean;
  sendReportToEmail: () => void;
}

const NormalReadingsReportHeader: FC<NormalReadingsReportHeaderProps> = ({
  isLoading,
  sendReportToEmail,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.header}>
      <NavigationHeader title={t('labels.normalReadingsReport')}>
        {withLoader(
          isLoading,
          <BaseDownloadButton
            onClick={sendReportToEmail}
            disabled={isLoading}
          />,
        )}
      </NavigationHeader>
    </div>
  );
};
export default NormalReadingsReportHeader;
